export default __webpack_public_path__ + "static/media/breath-1.cb0249b7.jpg";